// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { withLeaflet } from 'react-leaflet';
import type { LeafletContext } from 'react-leaflet/src';
import { withRouter } from 'react-router';
import { History, Match } from 'react-router-dom';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import GroupObjects from './GroupObjects';


const GROUP_PANEL_ID = 'GROUP_PANEL_ID';

type Props = {
    editor: BaseEditor,
    leaflet: LeafletContext,
    history: History,
    match: Match,
};

const GroupObjectsContainer = (props: Props) => {
    const {
        editor, leaflet: { map }, history, match,
    } = props;

    React.useEffect(() => {
        map.grouping = true;

        return () => {
            map.grouping = false;
        };
    }, [map]);

    return (
        <SidePane
            id={GROUP_PANEL_ID}
            openInitially
            title={(<FormattedMessage id="group-objects-title" defaultMessage="Group objects" />)}
            closePanel={GROUP_PANEL_ID}
        >
            <GroupObjects editor={editor} />
        </SidePane>
    );
};

export default withRouter(withLeaflet(GroupObjectsContainer));
